import React, { useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import advisoryIcon from './images/advisory.svg';
import deepenIcon from './images/deepen.svg';
import coreAdvisoryIcon from './images/coreAdvisory.svg';
import saasIcon from './images/saas.svg';
import { makeStyles } from '@mui/styles';
import TargetTableHeader from './TargetTableHeader';
import TargetTableRow from './TargetTableRow';
import { setPillarId } from '../../store/slices/targetSlice';

import {
    Box,
    IconButton,
    Table,
    TableBody
} from "@mui/material";

import {    
    ArrowForward
} from "@mui/icons-material"

const useStyles = makeStyles(() => ({
    table: {
        color: '#0a0047',
        "& tbody tr": {
            borderTop: '2px solid #d6d3e3'
        },
        "& td": {
            paddingLeft: '5px',
            height: '59px'
        },
        "& th": {
            paddingLeft: 0
        }
    }
}));

const BalancedScoreCard = ({ pillarId }) => {

    const dispatch = useAppDispatch();
    const { targets, pillars } = useAppSelector(state => state.targetReducer);

    const classes = useStyles();

    const icons = [
        advisoryIcon,
        coreAdvisoryIcon,
        saasIcon,
        deepenIcon
    ]; 

    const pillar = pillars.find(x => x.id === pillarId);

    const myTargets = useMemo(() => {
        return targets.filter((x => x.isBalanceScoreCard && x.pillarId === pillarId))
    }, [pillarId, targets]);  
    
    return (
        (<Box style={{ border: '1px solid #aaa5c3', borderRadius: '3px' }}>
            <Box display="flex" style={{ backgroundColor: '#f2f4fe', padding: '10px' }} alignItems="center">
                <img src={icons[0]} style={{ height: '30px', margin: '10px' }} alt={pillar.name} />
                <Box flexGrow={1} style={{ fontFamily: 'Times New Roman', fontSize: '1.5em' }}>{pillar.name}</Box>
                <IconButton onClick={() => dispatch(setPillarId(pillarId))} size="large"><ArrowForward /></IconButton>
            </Box>
            <Box style={{ backgroundColor: '#e2dff0', padding: '10px 20px' }}>
                <Table className={classes.table} size="small">
                    <TargetTableHeader />
                    <TableBody>{myTargets.map(t => <TargetTableRow key={t.targetId} target={t} />) }</TableBody>
                </Table>
            </Box>
        </Box>)
    );
}


export default BalancedScoreCard;
